import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, DatePipe, isPlatformBrowser, NgClass, NgIf } from '@angular/common';
import { Component, computed, effect, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, PLATFORM_ID, Renderer2, signal, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { faBookmark as faBookmarkSolid, faCrown, faLink, faLock, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { DateTime } from 'luxon';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AccordionModule } from 'primeng/accordion';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { GalleriaModule } from 'primeng/galleria';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButton } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { distinctUntilChanged, Subscription, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IAskAQuestionRequest } from '../../../models/IAskAQuestionRequest';
import { IBiddingRequest } from '../../../models/IBiddingRequest';
import { IFeeRequest } from '../../../models/IFeeRequest';
import { IItem } from '../../../models/IItem';
import { IItemBidHistory } from '../../../models/IItemBidHistory';
import { IItemDetails } from '../../../models/IItemDetails';
import { ILineItems } from '../../../models/ILineItems';
import { ITieDetails } from '../../../models/ITieDetails';
import { LineItemType } from '../../../models/line-item-type';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';
import { ApiService } from '../../../services/api.service';
import { AuthService, LOGIN_TYPE_BID_INLINE, LOGIN_TYPE_TICKETS, LOGIN_TYPE_TOPBAR } from '../../../services/authentication/auth.service';
import { BidService } from '../../../services/bidding/bid.service';
import { DateFormatService } from '../../../services/date-format/date-format.service';
import { EmbeddedPaymentService } from '../../../services/epf/embedded-payment.service';
import { FavoritesItemsService } from '../../../services/favorites/favorites-items.service';
import { ModalService } from '../../../services/modals/modal.service';
import { RecaptchaLoaderService } from '../../../services/recaptcha-loader.service';
import { ThemeService } from '../../../services/theme.service';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { CaptionBidPipe } from '../../../shared/pipes/caption-bid-history/caption-bid.pipe';
import { DonorsComponent } from '../../auctions/donors/donors.component';
import { FooterComponent } from '../../auctions/footer/footer.component';
import { HeaderComponent } from '../../auctions/header/header.component';
import { SearchBarComponent } from "../../auctions/items/search-bar/search-bar.component";
import { CreditCardInformationComponent } from '../../authentication/credit-card-information/credit-card-information.component';
import { SignInComponent } from '../../authentication/sign-in/sign-in.component';
import { BelowReserveBidComponent } from '../../bid-history-modals/below-reserve-bid/below-reserve-bid.component';
import { BelowReserveComponent } from '../../bid-history-modals/below-reserve/below-reserve.component';
import { ReserveMetComponent } from '../../bid-history-modals/reserve-met/reserve-met.component';
import { StraightBidComponent } from '../../bid-history-modals/straight-bid/straight-bid.component';
import { TieBidComponent } from '../../bid-history-modals/tie-bid/tie-bid.component';
import { EmbeddedPaymentComponent } from '../../embedded-payment/embedded-payment.component';
import { GalleryFullImageComponent } from "../../gallery-full-image/gallery-full-image.component";
import { AddToCartButtonComponent } from '../../shopping-cart/add-to-cart-button/add-to-cart-button.component';
import { AbsenteeBiddingComponent } from '../absentee-bidding/absentee-bidding/absentee-bidding.component';
import { BiddingQuestionMarkComponent } from '../bidding-question-mark/bidding-question-mark.component';

@Component({
  selector: 'app-items-fullpage',
  imports: [ButtonModule, CommonModule, InputGroupModule, SignInComponent,
    NgClass, RadioButton, SelectModule, FormsModule,
    NgIf,
    InputNumberModule,
    RouterModule,
    EmbeddedPaymentComponent,
    TabsModule,
    AccordionModule,
    DonorsComponent,
    TextareaModule,
    HeaderComponent,
    FooterComponent,
    ProgressSpinnerModule,
    FontAwesomeModule,
    BiddingQuestionMarkComponent,
    StraightBidComponent,
    TieBidComponent,
    BelowReserveBidComponent,
    ReserveMetComponent,
    CaptionBidPipe,
    GalleriaModule,
    BreadcrumbModule,
    SearchBarComponent,
    MessageModule,
    GalleryFullImageComponent,
    AddToCartButtonComponent,
    AbsenteeBiddingComponent,
    ClipboardModule
  ],
  providers: [DynamicDialogRef, DatePipe],

  templateUrl: './items-fullpage.component.html',
  styleUrl: './items-fullpage.component.scss'
})
export class ItemsFullpageComponent implements OnInit, OnChanges, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly themeService = inject(ThemeService);
  private readonly router = inject(Router);

  @Input() id!: number;
  @Output() bidCompleted = new EventEmitter<number>();

  protected quantity = signal(1);

  isFullPage: boolean = false;
  selectedImage!: string;
  itemMinimunBid!: number;
  itemMaximunBid!: number;
  idItemDetails: number = 0;
  auctionId: number | null = 0;
  itemModal?: IItemDetails | null = null;
  gallery: string[] = [];
  itemType: 'buy' | 'bid' | 'buy-bid' | 'event' | 'upcoming' | 'closed' | 'sold' = 'event';
  // winninBid: string = "The winning bid will  go to FrontStream Global Fund (tax ID 26-3265577), a 501c3 nonprofit organization, which  will send the donation to VOLUNTEERS OF AMERICA INC (tax ID 000000001) on behalf of the winner.";
  selectedCardId!: number;
  selectedBid: string = '';
  selectedBidOption: 'STRAIGHT' | 'PROXY' = 'PROXY';
  formatPlacedOnDate: string | null = '';
  formatBidHistory: IItemBidHistory[] = [];
  displayQuestionModal = false;
  displayAbsenteeBiddingModal = false;

  lastItemId!: number;

  protected creditCardErrorMessage = '';

  // Tabs
  filteredTab: { value: number, title: string }[] = [];
  tabs = [
    { value: 0, title: 'Item Details' },
    { value: 1, title: 'Ask a question' },
    { value: 2, title: 'FAQ' },
    { value: 3, title: 'Bid History' }
  ];
  activeTab: number = 0;
  faqs = [
    { question: 'How to Login / Register as a Bidder', answer: 'To participate in bidding, you need to register and sign in as a bidder. In the top-right corner, select either "Sign In" or "Register" and complete the form. If you forget your password, use the "Forgot Password" link from the "Sign In" screen.', value: '0' },
    { question: 'Contacting the Organization hosting the Event/Auction', answer: 'For questions or assistance, go to "Contact Us" in the footer. Another option is on the item’s page, select the "Ask a question" tab and fill out the form to contact the hosting organization directly.', value: '1' },
    { question: 'How to Add/Edit/Remove Credit Card Information', answer: 'To manage your credit card details, sign into your bidder account, select "Welcome, (your name)" in the header and then select "Credit Cards".', value: '2' },
    { question: 'Types of Bidding - Straight Bidding vs. Proxy Bidding', answer: 'Straight Bidding involves placing a bid at a specific amount. Proxy Bidding allows the system to bid on your behalf up to a Maximum Bid Amount you set.  The system will automatically increase your bid as needed to maintain your leading position up to that maxmimum amount.', value: '3' },
    { question: 'How to Request a Bid Retraction', answer: 'To retract a bid, contact the hosting organization directly. On the item’s page, select "Ask a question" to request a bid retraction. BiddingForGood cannot process bid retraction requests from bidders.', value: '4' },
  ];

  onTabChange(newTab: string | number | undefined) {
    if (newTab !== 1) {
      this.askAQuestionControl = '';
      this.responseError = '';
    }
    this.activeTab = Number(newTab);
  }
  //authentication process
  authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  isAuthenticated = this.oidcSecurityService.authenticated;
  isShowingLoginIframe = signal(false);
  loginPage = LOGIN_TYPE_BID_INLINE;
  loginUrl = signal('');

  // bid
  biddingService = inject(BidService);
  coverFeeConfirm: boolean = false;
  bidResponseSignal = signal<string | null>(null);
  showConfirmTemplate: boolean = false;
  showLowBidError: boolean = false;
  showBidStatus: boolean = false;
  errorMessage: string | null = null;
  public bidPlaceholder = '';
  userName!: string;
  showMaxBidError: boolean = false;
  myBidLabel!: string;

  //Bid history Modals
  displayStraigthBidModal: boolean = false;
  displayBelowReserveBidModal: boolean = false;
  displayReserveExplanationBidModal: boolean = false;
  displayReserveMetBidModal: boolean = false;
  displayTieWinBidModal: boolean = false;
  activeCaption: string | null = null;
  tieDetails: ITieDetails | null = null;

  captionLabels: Record<string, string> = {
    LEADING_BID: 'Leading Bid',
    TIE_WINNER: 'Tie Bid',
    RESERVE_MET: 'Reserve Met',
    BELOW_RESERVE: 'Below Reserve',
    LIVE_EVENT_BID: 'Live Event Bid',
    BID_EXTENSION: 'Bid Extension',
    STRAIGHT_BID: 'Straight Bid',
    BUY_NOW: 'Buy Now',
  }

  // paymentService = inject(EmbeddedPaymentComponent);
  apiService = inject(ApiService);
  modalService = inject(ModalService);
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);

  //embeddedPayment
  paymentService = inject(EmbeddedPaymentService);
  token: string = '';
  visibleEmbedded: boolean = false;
  feeSignal = this.paymentService.feeSignal;
  feeSignalValue: number | 0 = 0;
  loadingEPF = this.paymentService.loadingEPF;

  authSubscription!: Subscription;

  //loading
  isLoading: boolean = true;

  //favorite
  isFavorited: boolean = false;
  private readonly favoriteService = inject(FavoritesItemsService);
  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;

  faCrown = faCrown;
  faLock = faLock;
  faSquareCheck = faSquareCheck;
  faFacebook = faFacebook;
  faLinkedin = faLinkedin;
  faXTwitter = faXTwitter;
  faInstagram = faInstagram;
  faLink = faLink;

  //Ask a question
  askAQuestionControl: string = '';
  userEmail!: string;
  responseError!: string;

  //reCAPTCHA
  private readonly recaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly recaptchaLoader = inject(RecaptchaLoaderService);

  //api message service
  private readonly messageService = inject(ToastMessageService);

  //formate date service
  private readonly dateFormatService = inject(DateFormatService)

  // social media
  private readonly meta = inject(Meta);
  private readonly titleService = inject(Title);

  // breadcrumb
  itemsBreadcrumb: MenuItem[] = [];
  home!: MenuItem;


  homePageSignal = this.apiService.homePageSignal;
  auctionConfigSignal = this.apiService.auctionConfigSignal;

  itemDetailsSingalModal = computed(() => this.apiService.itemDetailSignal());
  safeDescriptionHtml = computed(() => this.sanitizeHtmlText(this.itemDetailsSingalModal()?.description || ''));
  safeSpecialNoteHtml = computed(() => this.sanitizeHtmlText(this.itemDetailsSingalModal()?.specialNote || ''));
  safeItemNameHtml = computed(() => this.sanitizeHtmlText(this.itemDetailsSingalModal()?.name || ''));
  itemFavoriteSignal = signal<boolean>(this.itemDetailsSingalModal()?.isFavorite ?? false);
   showCoverTheFee = computed(
      () => this.auctionConfigSignal()?.isCoverTheFeeEnabled
    );

  private getItemStatus(item: any): 'upcoming' | 'open' | 'closed' | 'unknown' {
    if (!item?.openingDate || !item?.closingDate) return 'unknown';

    const openingDate = DateTime.fromISO(item.openingDate);
    const closingDate = DateTime.fromISO(item.closingDate);
    const now = DateTime.now();

    if (now < openingDate) return 'upcoming';
    if (now >= openingDate && now < closingDate) return 'open';
    return 'closed';
  }

  itemDateFormat = computed(() => {
    const timezone = this.auctionConfigSignal()?.timezone || 'UTC';
    const closingDate = this.itemDetailsSingalModal()?.closingDate;

    if (!closingDate) return '';

    return this.dateFormatService.formatDateWithTimezone(timezone, closingDate);
  });

  openingDateFormat = computed(() => {
    const timezone = this.auctionConfigSignal()?.timezone || 'UTC';
    const openingDate = this.itemDetailsSingalModal()?.openingDate;

    if (!openingDate) return '';

    return this.dateFormatService.formatDateWithTimezone(timezone, openingDate);
  });

  protected showWinningBidText = computed(() => {
    return this.apiService.auctionConfigSignal()?.processor === 'pgf'
  });

  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '')

  cardOptions = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data) return [];

    return data.creditCards.map(card => ({
      label: `${card.type} ****${card.lastDigits}`,
      value: card.id
    }));
  });

  selectedCard = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data || data.creditCards.length === 0) return 0;

    const preferredCard = data.creditCards.find(card => card.id === data.preferredCardId);

    return preferredCard ? preferredCard.id : data.creditCards[0].id;
  });

  feeAmountSignal = computed(() => {
    const feeEndpoint = this.paymentService.feeSignal();
    if (!feeEndpoint) return 0;

    return feeEndpoint;

  });

    isAbsenteeBiddingEnabled = computed(
      () => this.apiService.auctionConfigSignal()?.isAbsenteeBiddingEnabled
    );

  constructor(private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute, private datePipe: DatePipe, private renderer: Renderer2) {
    effect(() => {
      const data = this.authService.creditCardSignal();
      if (data) {
        this.selectedCardId = this.selectedCard();
      }

    });

  }

  private unlistenMessage?: () => void; // for cleanup

  ngOnInit(): void {
    this.recaptchaLoader.load();

    this.isFullPage = true;

    this.loadingEPF.set(false);

    this.activatedRoute.paramMap.subscribe(params => {
      this.auctionId = Number(params.get('idAuction'));
      this.idItemDetails = Number(params.get('idItem'));

    });
    this.home = { icon: 'pi pi-home', routerLink: `/auction/${this.auctionId}` };

    if (isPlatformBrowser(this.platformId)) {
      this.themeService.customizeAuctionTheme(this.auctionId!);
      this.themeService.setPreset('bfg');
    }

    this.getItemDetails(this.idItemDetails);


    if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()) {
      this.authService.getCreditCard().subscribe();
    }

    if (!this.auctionConfigSignal()) {
      this.apiService.getAuctionConfig(this.auctionId ?? 0).subscribe(
        (config) => {
          if (config.isCoverTheFeeEnabled && config.isCoverTheFeeOnByDefault) {
            this.coverFeeConfirm = true;
          }
        }
      );
    } else {
      if (this.auctionConfigSignal()?.isCoverTheFeeEnabled && this.auctionConfigSignal()?.isCoverTheFeeOnByDefault) {
        this.coverFeeConfirm = true;
      }
    }


    this.authSubscription = this.authService.isAuthenticated$
      .pipe(distinctUntilChanged())
      .subscribe(isAuth => {
        if (isAuth) {
          if (this.isFullPage) {
            this.getItemDetails(this.idItemDetails);
          }
        } else {
          if (this.isFullPage) {
            this.authService.creditCardSignal.set(null);
            this.getItemDetails(this.idItemDetails);
            this.isFavorited = false;
          }
          this.isFavorited = false;
        }
      });

    // Add window message listener for Unavailable Notification support
    this.unlistenMessage = this.renderer.listen('window', 'message', this.onHandleEpfMessage);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.getItemDetails(this.idItemDetails);
  }

  ngOnDestroy() {
    this.recaptchaLoader.unload();
    this.authSubscription?.unsubscribe();
    // clean up the window listener if it was registered
    if (this.unlistenMessage) {
      this.unlistenMessage();
      this.unlistenMessage = undefined;
    }
  }

  onHandleEpfMessage = (event: any) => {
    if (event.data !== null) {
      if (event.data.type === "ITEM_UNAVAILABLE") {
        this.visibleEmbedded = false; // this closes modal
        window.location.reload();
      } else if (event.data.type === "EPF_REDIRECT_PARENT_WITH_URL" && event.data.url) {
        console.log('Redirect to Thank You page');
        this.visibleEmbedded = false; // this closes modal
        window.location.replace(event.data.url);
      }

    }
  };

  //authentication
  showLoginIframe() {
    // console.log('here');
    this.getLoginUrl();
  }

  getLoginUrl() {
    let urlHandler = (url: string) => {
      // console.log(url)
      this.loginUrl.set(url);
      this.isShowingLoginIframe.set(true);
    }
    let messageCallback = () => {
      this.isShowingLoginIframe.set(false);
    }
    this.authService.login(urlHandler, messageCallback, false, 0);
  }

  openLoginModal() {
    // console.log("login")
    if (this.auctionId != null) {
      const isTestAuction = this.auctionConfigSignal()?.isTestAuction;
      this.authService.openLoginModal(LOGIN_TYPE_TICKETS, this.embeddedPaymentLoad, this.auctionId, this.embeddedPaymentLoad, '', { hideGuestOption: isTestAuction });
    }
  }

  getItemDetails(itemId: number): void {
    const endpoint = 'items';
    this.apiService.getItemById(endpoint, itemId).pipe(
      tap({
        next: (response) => {

          const item = this.itemDetailsSingalModal();

        // console.log(item,   item!.absenteeBiddingEnabled);

          this.idItemDetails = item!.id;
          this.auctionId = item?.auctionId ?? null;

          // Breadcrumb
          this.itemsBreadcrumb = [
            { label: 'All Items', routerLink: `/item-list/${this.auctionId}` },
            { label: item?.name }
          ]

          if (item?.minimumBid) {
            this.itemMinimunBid = parseFloat(item!.minimumBid.replace(/[^0-9.]/g, ''));;
          }

          if (item?.myMaxBid) {
            this.itemMaximunBid = parseFloat(item!.myMaxBid.replace(/[^0-9.]/g, ''));;
          }

          if (item) {

            if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()) {
              this.authService.getCreditCard().subscribe();
            }

            this.itemModal = item;
            this.itemType = this.resolveItemType(item);
            this.isLoading = false;

            // console.log('isFavorite', item.isFavorite)

            this.isFavorited = item.isFavorite;
            this.itemFavoriteSignal.set(this.isFavorited);

            //populate gallery
            const mainImage = item.imageUrl?.trim()
              ? (item.imageUrl.startsWith('http') ? item.imageUrl : `${environment.apiUrl}/${item.imageUrl.trim()}`)
              : '/item-default.jpg';
            this.itemModal.imageUrl = mainImage;
            this.selectedImage = mainImage;


            const additionalImages = (item.additionalImagesUrls || [])
              .filter(img => img && img.trim() && img.trim() !== item.imageUrl?.trim())
              .map(img => img.startsWith('http') ? img.trim() : `${environment.apiUrl}/${img.trim()}`);


            setTimeout(() => {
              this.gallery = [mainImage, ...additionalImages];
              this.selectedImage = mainImage;
            }, 0);

            this.bidPlaceholder = this.getBidPlaceholder();

            // }
            if (item.isBiddable) {

              this.loadItemBidHistory(item.id);
            }

          }
          this.filteredTab = this.itemModal?.isBiddable
            ? this.tabs
            : this.tabs.filter(t => t.value !== 3);
        },
        error: (error) => {
          console.error('Error fetching item details:', error);
        }
      })
    ).subscribe();
  }

  private resolveItemType(item: any): 'buy' | 'bid' | 'buy-bid' | 'event' | 'upcoming' | 'closed' | 'sold' {
    const status = this.getItemStatus(item);

    if (status === 'closed') return 'closed';
    if (status === 'upcoming' && item.biddingType !== 'LIVE_ONLY') return 'upcoming';
    if (item.biddingType === 'LIVE_ONLY') return 'event';
    if (item.biddingType === 'BUY_NOW_ONLY' && !item.isBuyable && !item.isBiddable) return 'sold';
    if (!item.isBuyable && !item.isBiddable && item.quantityAvailable === 0 && item.quantityAvailable === 0 ) return 'sold';
    if (item.isBuyable && item.isBiddable) return 'buy-bid';
    if (item.isBuyable) return 'buy';
    if (item.isBiddable) return 'bid';
    return 'event';
  }

  loadItemBidHistory(itemId: number): void {

    this.oidcSecurityService.getUserData().subscribe(result => {
      if (result) {
        this.userName = result.preferred_username
      } else {
        this.userName = '';
      }
    });

    const endpoint = 'items';
    this.apiService.getItemBidHistory(endpoint, itemId).pipe(

      tap({
        next: (response) => {
          this.formatBidHistory = JSON.parse(JSON.stringify(response));
          this.formatBidHistory.forEach(bid => {
            if (bid.placedOn) {
              bid.placedOn = this.formatDate(bid.placedOn);
            }
          });
        },
        error: (error) => {
          console.error('Error fetching bid history:', error);

        }
      })
    ).subscribe();
  }

  formatDate(fecha: string): string {

    if (typeof window !== 'undefined') {
      // console.log('formated');
      const cleanedFecha = fecha.replace(/\[.*\]$/, '');
      const date = new Date(cleanedFecha);

      if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }
      return this.formatPlacedOnDate = this.datePipe.transform(date, 'MMM dd\'th\', h:mm a')!;
    }

    return '';
  }

  protected lineItems = computed(() => {
    const lineItems: ILineItems[] = [
      { id: this.idItemDetails, type: LineItemType.Item, quantity: this.quantity(), donationAmount: 0.0 }
    ];
    return lineItems;
  });

  protected showAddToCartButton = computed(() => {
    const config = this.auctionConfigSignal();
    if (config != null) {
      return config.isUsingShoppingCart;
    }
    return false;
  });

  private getCreditCardErrorMessage = (cardId:number|null|undefined) => {
    if (cardId === null || cardId === undefined) {
      return 'Please select a card to place your bid.'
    }
    return '';
  }

  //embedded payment form
  embeddedPaymentLoad = (): void => {

    const lineItems: ILineItems[] = [
      { id: this.idItemDetails, type: 3, quantity: this.quantity(), donationAmount: 0.0 }
    ];

    if (this.auctionConfigSignal()?.isTestAuction) {
      this.paymentService.postTestPurchase(this.auctionId!, lineItems).subscribe({
        next: () => {
          this.router.navigate(['/payment-successful']);
        },
        error: (error) => {
          console.error('Error processing test purchase:', error);
        }
      });
      return;
    }

    this.paymentService.postEmbeddedPayment(this.auctionId!, lineItems).subscribe({
      next: (token) => {
        this.openEmbeddedPayment(token);
      },
      error: (error) => {
        console.error('Error al obtener el token:', error);
      }
    })
  }

  openEmbeddedPayment(token: string) {
    this.token = token;
    this.visibleEmbedded = true;
  }

  //bidding process

  placeABid() {

    const biddingData: IBiddingRequest = {
      selectedCard: this.selectedCardId,
      bidType: this.selectedBidOption,
      amount: Number(this.selectedBid),
      coverTheFee: this.coverFeeConfirm,
      isFromBidderCommunity: false
    }

    // console.log(biddingData, this.idItemDetails)

    this.biddingService.postBidding(this.idItemDetails, biddingData).subscribe({
      next: (response: string) => {
        try {
          const parsed = JSON.parse(response);
          this.bidResponseSignal.set(parsed.status ?? '');
          this.showBidStatus = true;
          this.showConfirmTemplate = false;
          this.getItemDetails(this.idItemDetails);
          this.bidCompleted.emit();

        } catch (error) {
          console.error('Error parsing response:', error);
          this.bidResponseSignal.set('');
        }
      },
      error: (err) => {
        const parsed = JSON.parse(err.error);
        this.errorMessage = parsed.message;
        this.showLowBidError = true;
      }
    })
  }

  selectedCardName(): string | null {
    const selected = this.cardOptions().find(card => card.value === this.selectedCardId);
    return selected?.label || '';
  }

  onAddCreditCard() {
    this.modalService.openModal('credit-card', CreditCardInformationComponent, {
      width: '500px',
      modal: true,
      closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      },
      data: {
        // onCardAdded: () => this.loadCards()
      }
    });
  }

  goBack() {
    window.history.back();
  }

  // hideError() {
  //   this.showMaxBidError = false;
  //   this.showLowBidError = false;
  // }

  protected validateBid(): boolean {

    let valid = true;
    valid = valid && this.validateWholeNumber(this.selectedBid);
    valid = valid && this.errorLowBid();
    valid = valid && this.validateCreditCard();

    if (valid) {
      this.getFeeEndpoint();
      this.showConfirmTemplate = true;
    }
    return valid;
  }

  private validateCreditCard = () => {
    this.creditCardErrorMessage = this.getCreditCardErrorMessage(this.selectedCardId);
    return this.creditCardErrorMessage === '';
  }

  private validateWholeNumber(value: string): boolean {
    try {
      const regex = /^[0-9]+$/;
      return regex.test(value);
    } catch (error) {
      console.error("Error validating whole number:", error);
    }
    return false;
  }

  private errorLowBid() {
    if (this.selectedBid == null || this.selectedBid === '') {
      return false;
    }

    const bid = Number(this.selectedBid);


    if (this.itemMaximunBid != null && bid <= this.itemMaximunBid) {
      this.showMaxBidError = true;
      return false;
    } else if (this.itemMinimunBid > bid) {
      this.showLowBidError = true;
      return false;
    }

    return true;

  }
  hideConfirmTemplate() {
    this.showConfirmTemplate = false;
  }

  onClickBack() {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
  }
  resetVariables() {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
    this.showBidStatus = false;
    this.bidResponseSignal.set('');
    this.selectedBidOption = 'PROXY';
    this.selectedBid = '';
    this.coverFeeConfirm = this.auctionConfigSignal()?.isCoverTheFeeEnabled &&
      this.auctionConfigSignal()?.isCoverTheFeeOnByDefault ? true : false;
  }

  sanitizeHtmlText(content: string): SafeHtml {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const txt = document.createElement('textarea');
      txt.innerHTML = content;
      const decodedContent = txt.value;
      return decodedContent ? this.sanitizer.bypassSecurityTrustHtml(decodedContent) : '';
    }
    return '';
  }

  onQuestionMark() {
    this.displayQuestionModal = true;
  }

  onModalClose() {
    this.displayQuestionModal = false;
  }

  onAbsenteeBidModal(){
    this.displayAbsenteeBiddingModal = true;
  }

  getBidPlaceholder(): string {
    const format = (amount: number) => `$${amount} ${this.currency()}`;

    const maxBid = Number(this.itemMaximunBid);
    const minBid = Number(this.itemMinimunBid);

    if (this.itemModal?.isLeader && maxBid >= minBid) {
      this.myBidLabel = 'Increase my bid to:';
      return `${format(maxBid + 1)} Next Minimum Bid`;
    }

    if (this.itemModal?.isLeader && maxBid < minBid) {
      this.myBidLabel = 'Increase my bid to:';
      return `${format(minBid)} Next Minimum Bid`;
    }

    this.myBidLabel = 'My Bid:';
    return `${format(minBid)} Next Minimum Bid`;

  }

  openLoginModalFavorite(fun?: () => void) {
    if (this.auctionId != null) {
      this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun, this.auctionId);
    }
  }

  itemFavorite = () => {

    if (!this.isAuthenticated().isAuthenticated) {
      this.openLoginModalFavorite();
      return;
    }

    this.favoriteService.putFavorite(this.idItemDetails).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        this.isFavorited = true;
        this.itemFavoriteSignal.set(true);

      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }
  removeItemFavorite() {

    this.favoriteService.deleteFavorite(this.idItemDetails).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        this.isFavorited = false;
        this.itemFavoriteSignal.set(false);

      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }

  toggleFavorite(): void {
    if (this.isFavorited) {
      this.removeItemFavorite();
    }
    else {
      this.itemFavorite();
    }
  }

  onFavoriteChanged(updatedItem: IItem): void {
    const favorite = updatedItem.isFavorite ?? false;
    this.itemModal!.isFavorite = favorite;
    this.isFavorited = favorite;
  }

  openCaptionModal(caption: string, bid: IItemBidHistory): void {

    switch (caption) {
      case 'STRAIGHT_BID':
        this.displayStraigthBidModal = true;
        break;
      case 'BELOW_RESERVE':
        this.displayBelowReserveBidModal = true;
        break;
      case 'RESERVE_MET':
        this.displayReserveMetBidModal = true;
        break;
      case 'TIE_WINNER':
        this.tieDetails = bid.tieDetails;
        this.displayTieWinBidModal = true;
        break;
    }
  }

  onModalExplanationClose() {
    // console.log(this.activeCaption);
    switch (this.activeCaption) {
      case 'STRAIGHT_BID':
        this.displayStraigthBidModal = false;
        break;
      case 'BELOW_RESERVE':
        this.displayBelowReserveBidModal = false;
        break;
      case 'RESERVE_MET':
        this.displayReserveMetBidModal = false;
        break;
      case 'TIE_WINNER':
        this.displayTieWinBidModal = false;
        break;
    }
  }

  openReserveModal() {

    this.modalService.openModal('has-reserve-item', BelowReserveComponent, {
      width: '500px',
      modal: true,
      // closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      }
    });
  }

  onAskAQuestion() {
    if (this.askAQuestionControl && this.askAQuestionControl.trim() !== '') {
      if (this.isAuthenticated().isAuthenticated) {
        this.postAsqkAQuestion()
      } else {
        this.openLoginModalFavorite(this.postAsqkAQuestion);
      }
    } else {
      this.responseError = 'Question is a required field';
      return;
    }
  }

  onQuestionChange() {
    if (this.askAQuestionControl.trim() !== '')
      this.responseError = '';
  }

  postAsqkAQuestion = (): void => {
    this.oidcSecurityService.getUserData().subscribe(result => {
      if (result) {
        this.userEmail = result.email ?? '';
      }
    });

    const askAQuestionObj: IAskAQuestionRequest = {
      question: this.askAQuestionControl,
      email: this.userEmail ?? 'test@gmail.com'
    };

    this.recaptchaV3Service.execute(environment.siteKey, 'ask_question', (token: string) => {

      const recaptchaDom = document.querySelector('.grecaptcha-badge') as HTMLElement;

      recaptchaDom.style.visibility = 'visible';

      this.apiService.postAskAQuestion(this.idItemDetails, askAQuestionObj, token).subscribe({
        next: (response) => {
          this.messageService.success(`Your question has been sent to the auction team. They will contact you at ${this.userEmail} within a few days. `);
        },
        error: (err) => {
          let errorMsg = 'unknown error';

          if (typeof err.error === 'string') {
            try {
              const parsed = JSON.parse(err.error);
              errorMsg = parsed.message || errorMsg;

            } catch (e) {
              errorMsg = err.error;
            }
          }
          else if (err.error && err.error.errorMessage) {
            errorMsg = err.error.errorMessage;
          }

          this.messageService.error(errorMsg || 'unknown error');
        }
      });

      setTimeout(() => {
        recaptchaDom.style.visibility = 'hidden';
        this.askAQuestionControl = '';
      }, 3000);
    });
  }

  getFeeEndpoint() {
    const coverFeeData: IFeeRequest = {
      auctionId: this.auctionId!,
      amount: Number(this.selectedBid),
      purchaseType: 3
    }

    this.paymentService.getFee(coverFeeData).subscribe({
      next: (response) => {
        this.feeSignalValue = response;
      }
    });

  }

  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }

  protected baseShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId) && {type: 'item', id:this.idItemDetails}) {
      const { type, id } = {type: 'item', id:this.idItemDetails};
      return `${environment.apiUrl}/v3/social-media-sharing/${type}/${id}`;
    }
    return "";
  })


  protected openPopupCenter(pageURL: string, title: string, w: number, h: number) {
    if (isPlatformBrowser(this.platformId)) {
      var windowSize = {
        width: w,
        height: h
      };
      var windowLocation = {
        left: ((window.screen.availWidth / 2) - (windowSize.width / 2)),
        top: ((window.screen.availHeight / 2) - (windowSize.height / 2))
      };
      window.open(pageURL, title, 'width=' + w + ', height=' + h + ', left=' + windowLocation.left + ', top=' + windowLocation.top);
    }
  }

    protected facebookShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    }
    return "";
  })


  protected twitterShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url);
    }
    return "";
  })

  protected linkedinShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(url);
    }
    return "";
  })

  protected copyUrl = computed(()=> {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return url;
    }
    return "";
  })

  protected onCopyUrl() {
    this.messageService.success('URL copied to clipboard!');
  }
}

